export default __webpack_public_path__ + "static/fixed-buy-52d97266be1b70cb59cafb9bea432822.png";